import {
    Container,
    Button,
    Dialog,
    DialogContent,
    Snackbar,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import SelectFPFormCompany from "../../components/SelectFPFormCompany";
import { useEffect, useMemo, useState } from "react";
import CompanyApi from "../../services/company.service";
import FPFormSelect from "../../components/FPFormSelect";
import PlatformSelect from "./PlatformSelect";
import {
    CURRENT_PLATFORM,
    CROSS_PLATFORM,
    FORM_KEYS,
    SECTIONS_KEYS,
    FIELD_KEYS,
} from "../../common/constants";
import ForwardSVG from "./ForwardSVG";

const useStyles = makeStyles({
    source: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "220px",
    },
    target: {
        width: "40%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "220px",
    },
    arrow: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        height: "220px",
    },
    container: {
        display: "column",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "space-around",
        marginTop: "55px",
        padding: "0px 0px",
    },
    button: {
        width: "10%",
    },
    selectOptions: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "space-between",
        margin: "20px 0px",
    },
});

const FPFormMigration = () => {
    const classes = useStyles();
    const [fpFormList, setFPFormList] = useState<any>([]);
    const [formsToMigrate, setFormsToMigrate] = useState<any>([]);
    const [targetCompany, setTargetCompany] = useState<any>(null);
    const [sourceCompany, setSourceCompany] = useState<any>(null);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState<any>(null);
    const [snackBar, setSnackBar] = useState("");
    const [selectedPlatfrom, setSelectedPlatform] =
        useState<string>(CURRENT_PLATFORM);
    const platforms: any = useMemo(
        () => [CURRENT_PLATFORM, CROSS_PLATFORM],
        []
    );

    const apiservices = new CompanyApi();

    const removeGeneratedKeys = (template = {}) => {
        const flushedTemplate: any = { ...template };
        for (const formKey of FORM_KEYS) {
            delete flushedTemplate[formKey];
        }
        const { sections = [] } = flushedTemplate;
        for (const section of sections) {
            for (const sectionKey of SECTIONS_KEYS) {
                delete section[sectionKey];
            }
            const { fields = [] } = section;
            for (const field of fields) {
                for (const fieldKey of FIELD_KEYS) {
                    delete field[fieldKey];
                }
            }
        }
        return flushedTemplate;
    };

    const removeGeneratedKeysBulk = (templates = []) => {
        const flushedTemplates = [];
        for (const template of templates) {
            flushedTemplates.push(removeGeneratedKeys(template));
        }
        return flushedTemplates;
    };

    const getFPformList = async () => {
        const result = (await apiservices.getFPformList()) || [];
        setFPFormList(result || []);
    };

    const migrateFPForms = async () => {
        if (formsToMigrate.length > 0) {
            if (!targetCompany) {
                setErrorDialog(true);
                setErrorMessage("Select Target company");
                return;
            }
            const forms = removeGeneratedKeysBulk(formsToMigrate);
            try {
                await apiservices.addFPForm(
                    {
                        formsList: forms,
                        sourceCompany,
                        targetCompany,
                        sourcePlatform: CURRENT_PLATFORM,
                        targetPlatform: selectedPlatfrom,
                    },
                    selectedPlatfrom
                );
                setSnackBar("success");
            } catch (error: any) {
                console.error(error);
                setSnackBar("error");
            }
        } else {
            setErrorDialog(true);
            setErrorMessage("Please select forms to migrate");
        }
    };

    useEffect(() => {
        console.log(fpFormList);
        setFormsToMigrate([]);
    }, [fpFormList]);

    useEffect(() => {
        if (sourceCompany) {
            setTargetCompany(null);
            getFPformList();
        }
    }, [sourceCompany]);

    return (
        <div>
            <Container className={classes.container}>
                <div className={classes.selectOptions}>
                    <div className={classes.source}>
                        <h3 style={{ textAlign: "center" }}>Source</h3>
                        <SelectFPFormCompany
                            isDisabled={false}
                            optionSelectedHandler={setSourceCompany}
                            selectedCompanyDetails={sourceCompany}
                        />
                        <FPFormSelect
                            formList={fpFormList}
                            optionsSelectedHandler={setFormsToMigrate}
                            value={formsToMigrate}
                        />
                    </div>
                    <div className={classes.arrow}>
                        <ForwardSVG />
                    </div>
                    <div className={classes.target}>
                        <h3 style={{ textAlign: "center" }}>Target</h3>
                        <PlatformSelect
                            platforms={platforms}
                            updatePlatformhandler={setSelectedPlatform}
                        />
                        <SelectFPFormCompany
                            isDisabled={formsToMigrate.length === 0}
                            disableOptions={sourceCompany}
                            optionSelectedHandler={setTargetCompany}
                            placeholder={"Target Company"}
                            migrationPlatform={selectedPlatfrom}
                            selectedCompanyDetails={targetCompany}
                        />
                    </div>
                </div>

                <div className={classes.button}>
                    <Button
                        className="rediscache_body"
                        style={{ margin: 10 }}
                        variant="outlined"
                        onClick={migrateFPForms}
                    >
                        Migrate
                    </Button>
                </div>
            </Container>
            <Dialog
                open={errorDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>{errorMessage}</DialogContent>
                <Button onClick={() => setErrorDialog(false)}>Ok</Button>
            </Dialog>
            <Snackbar
                open={snackBar === "" ? false : true}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                autoHideDuration={6000}
                onClose={() => {
                    setSnackBar("");
                }}
            >
                <Alert
                    severity={snackBar === "error" ? "error" : "success"}
                    onClose={() => {
                        setSnackBar("");
                    }}
                >
                    {snackBar === "success"
                        ? "Successfully migrated the FP Form"
                        : "Failed to migrate FP Forms"}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default FPFormMigration;
